<template>
  <transition
    :name="transitionName"
    appear
    @before-enter="onBeforeEnter"
    @before-leave="onBeforeLeave"
  >
    <div class="work-list-item" @click="goToMyWork">
      <div class="order">
        <div class="order-left">
          <span class="order-left-num">NO.{{ showOrderId }}</span>
          <span class="order-left-status status-top" v-if="isTop">{{
            languages.toTop
          }}</span>
        </div>
        <div class="order-right">
          <a
            class="order-right-opera iconfont icon-dian"
            href="javascript:;"
            @click.stop="switchVisibleBtn(true)"
          >
          </a>
        </div>
      </div>
      <p class="title">
        <span class="title-cont van-ellipsis">
          {{ workItem.SUBJECT }}
        </span>
        <span class="title-date">{{ formatCreateTime }}</span>
      </p>
      <div class="reply">
        <div class="reply-top">
          <em class="reply-top-icon iconfont icon-user"></em>
          <span class="reply-top-server">
            {{ workItem.GAME_SERVER_NAME || '' }}
          </span>
          <span v-if="workItem.CHARACTER_NAME">-</span>
          <span class="reply-top-role">
            {{ workItem.CHARACTER_NAME || '' }}
          </span>
        </div>
        <p class="reply-bottom">
          <span class="reply-bottom-text van-ellipsis">
            {{ workItem.LAST_MESSAGE || workItem.MESSAGE }}
          </span>
          <em v-if="unReadNum != 0" class="reply-bottom-icon iconfont icon-msg">
            <span class="reply-bottom-num">{{ unReadNum }}</span>
          </em>
        </p>
      </div>
      <div class="mask" :class="{ show: visibleControl }"></div>
      <div class="btn" :class="{ show: visibleControl }">
        <a
          class="btn-mask"
          href="javascript:;"
          @click.stop="switchVisibleBtn(false)"
        ></a>
        <div class="btn-main">
          <van-button
            class="btn-main-top"
            type="primary"
            @click.stop="topWorkItem"
          >
            <template #icon>
              <em class="iconfont icon-up"></em>
            </template>
            {{ isTop ? languages.cancelToTop : languages.toTop }}
          </van-button>
          <van-button
            class="btn-main-cancel"
            type="primary"
            @click.stop="cancelWorkItem"
          >
            <template #icon>
              <em class="iconfont icon-delete"></em>
            </template>
            {{ languages.delete }}
          </van-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import formatDate from '@utiles/formatDate.js';
import {
  clickButton,
  locationType
} from '@plugins/biPoint/_configOfficialSupport';
import { buildMyWorkQuery } from '@utiles/officialSupport';
export default {
  name: 'workListItem',
  props: {
    // 工单数据项
    workItem: {
      type: Object,
      required: true
    },
    // 工单索引
    index: {
      type: Number,
      required: true
    },
    // 控制操作按钮是否显示
    visibleControl: {
      type: Boolean,
      default: false
    },
    // 动画延迟时间
    transitionDelay: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      transitionName: 'slide-up',
      delayAni: 0
    };
  },
  created() {
    this.delayAni = this.transitionDelay;
  },
  computed: {
    ...mapState({
      languages: state => state.languages
    }),
    formatCreateTime() {
      const date = new Date(this.workItem.CREATE_TIME * 1000);
      return formatDate(date, 'MM/dd/yyyy');
    },
    // 是否置顶
    isTop() {
      return this.workItem?.IS_TOP == 1;
    },
    // 动画延迟时间
    transitionDelayStyle() {
      return `transition-delay: ${this.delayAni}s`;
    },
    // 未读消息数
    unReadNum() {
      const UNREAD_COUNT = this.workItem?.UNREAD_COUNT;
      if (UNREAD_COUNT) {
        if (UNREAD_COUNT > 99) {
          return '99+';
        } else {
          return UNREAD_COUNT;
        }
      } else {
        return '0';
      }
    },
    showOrderId() {
      if (this.workItem?.IS_SUPPORT_CREATE_AIBOT_ORDER == '1') {
        return `A${this.workItem?.SUPPORT_ORDER_ID}`;
      }
      return this.workItem?.SUPPORT_ORDER_ID;
    }
  },
  methods: {
    onBeforeEnter(el) {
      el.setAttribute('style', `transition-delay: ${this.delayAni}s`);
    },
    onBeforeLeave(el) {
      el.setAttribute('style', `transition-delay: 0`);
    },
    switchVisibleBtn(bool) {
      this.$emit('updateVisibleControl', bool, this.index);
    },
    goToMyWork() {
      const query = this.$route.query;
      const workId = this.workItem.SUPPORT_ORDER_ID;
      clickButton({
        btnName: 'clickToWork',
        locationKey: locationType.orderListPage,
        otherParams: {
          workId
        }
      });
      this.$router.push({
        name: 'mywork',
        params: { workId },
        query: buildMyWorkQuery(query, this.workItem)
      });
    },
    topWorkItem() {
      this.$emit('topWorkItem');
      this.switchVisibleBtn(false);
    },
    cancelWorkItem() {
      clickButton({
        btnName: 'clickDeleteWorkItem',
        locationKey: locationType.orderListPage,
        otherParams: {
          workId: this.workItem.SUPPORT_ORDER_ID
        }
      });
      // 关闭使用缩放动画
      this.delayAni = 0;
      this.transitionName = 'scale-in';
      this.$emit('cancelWorkItem', this.workItem, this.index);
      this.switchVisibleBtn(false);
    }
  }
};
</script>

<style lang="scss" scoped>
.work-list-item {
  $h: 148px;
  $btnH: 73px;

  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: $h;
  margin: 0 auto 18px;
  padding: 15px 13px;
  border-radius: 6px;
  background-color: var(--block-bg-light-color);
  box-shadow: 0px 3px 10px 0px rgba(51, 51, 51, 0.1);
  cursor: pointer;

  .order {
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 10px;
    &-left {
      font-size: 12px;
      &-num {
        padding: 2px 6px;
        margin-right: 6px;
        background-color: #eee;
        border-radius: 6px;
        line-height: 18px;
      }
      &-status {
        padding: 2px 6px;
        margin-right: 6px;
        border-radius: 6px;
        line-height: 18px;
        color: var(--text-on-main-bg-color);

        &.status-top {
          background-color: #9747ff;
        }
        &.status-evaluate {
          background-color: #eee;
          color: var(--text-color);
        }
      }
    }
    &-right {
      &-opera {
        padding: 0 0 0 8px;
        font-size: 18px;
        color: #999999;
      }
    }
  }

  .title {
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 10px;
    line-height: 20px;
    &-cont {
      display: inline-block;
      width: 260px;
      font-size: 15px;

      font-weight: 500;
    }
    &-date {
      font-size: 12px;
      color: var(--placeholder-color);
    }
  }

  .reply {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    box-sizing: border-box;
    height: 61px;
    padding: 10px 12px;
    border-radius: 9px;
    background-color: #eeeeee;
    font-size: 12px;
    &-top {
      &-icon {
        margin-right: 2px;
        font-size: 12px;
      }
    }
    &-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      &-text {
        display: inline-block;
        width: 300px;
        color: #999999;
      }
      &-icon {
        position: relative;
        display: inline-block;
        font-size: 20px;
        color: var(--main-color);
      }
      &-num {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 12px;
        font-weight: bold;
        color: var(--text-on-main-bg-color);
      }
    }
  }

  .mask {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0;
    transition-timing-function: ease;
    transition-duration: 0.5s;
    pointer-events: none;

    &.show {
      opacity: 1;
    }
  }

  .btn {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    margin: auto;
    transform: translate3d(0, 100%, 0);
    transition-timing-function: ease;
    transition-duration: 0.5s;

    &.show {
      transform: translate3d(0, 0, 0);
    }

    &-mask {
      display: block;
      width: 100%;
      height: $h - $btnH;
    }

    &-main {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-top,
      &-cancel {
        width: 50%;
        height: $btnH;
        border: 0;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        font-size: 15px;

        .iconfont {
          margin-right: 2px;
          font-size: 26px;
        }
      }

      &-top {
        background-color: #9747ff;
        border-bottom-right-radius: 0;
      }
      &-cancel {
        background-color: #fc4141;
        border-bottom-left-radius: 0;
      }
    }
  }
}
</style>
